<template>
  <data-list
    :data="data || list"
    :columns="columns"
    :isShowHeader="isShowHeader"
    :table-style="{name:'mixture'}"
  ></data-list>
</template>
<script>
import setmeal from '@/backend/services/account/setmeal.js';

export default {
  props: {
    data: {
      type: Array,
    },
    columns: {
      type: Array,
    },
    isShowHeader: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      list: []
    }
  },
  methods: {
    async query({id}){
      let res = await setmeal.setMealHistoryLists({
        id
      })
      this.list = res.data
    }
  },
}
</script>
